/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tracking_ReadyInputs */

const en_tracking_ready = /** @type {(inputs: Tracking_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracking Ready`)
};

const es_tracking_ready = /** @type {(inputs: Tracking_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguimiento Listo`)
};

const fr_tracking_ready = /** @type {(inputs: Tracking_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivi prêt`)
};

const de_tracking_ready = /** @type {(inputs: Tracking_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracking bereit`)
};

const id_tracking_ready = /** @type {(inputs: Tracking_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelacakan Siap`)
};

/** @type {(inputs: Tracking_ReadyInputs) => LocalizedString} */
const ja_tracking_ready = en_tracking_ready;

/** @type {(inputs: Tracking_ReadyInputs) => LocalizedString} */
const zh_tracking_ready = en_tracking_ready;

/** @type {(inputs: Tracking_ReadyInputs) => LocalizedString} */
const ar_tracking_ready = en_tracking_ready;

/** @type {(inputs: Tracking_ReadyInputs) => LocalizedString} */
const it_tracking_ready = en_tracking_ready;

/** @type {(inputs: Tracking_ReadyInputs) => LocalizedString} */
const ru_tracking_ready = en_tracking_ready;

/** @type {(inputs: Tracking_ReadyInputs) => LocalizedString} */
const pt_tracking_ready = en_tracking_ready;

/** @type {(inputs: Tracking_ReadyInputs) => LocalizedString} */
const ko_tracking_ready = en_tracking_ready;

/**
* | output |
* | --- |
* | "Tracking Ready" |
*
* @param {Tracking_ReadyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const tracking_ready = /** @type {((inputs?: Tracking_ReadyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tracking_ReadyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tracking_ready(inputs)
	if (locale === "es") return es_tracking_ready(inputs)
	if (locale === "fr") return fr_tracking_ready(inputs)
	if (locale === "de") return de_tracking_ready(inputs)
	if (locale === "ja") return ja_tracking_ready(inputs)
	if (locale === "zh") return zh_tracking_ready(inputs)
	if (locale === "ar") return ar_tracking_ready(inputs)
	if (locale === "id") return id_tracking_ready(inputs)
	if (locale === "it") return it_tracking_ready(inputs)
	if (locale === "ru") return ru_tracking_ready(inputs)
	if (locale === "pt") return pt_tracking_ready(inputs)
	return ko_tracking_ready(inputs)
});